const bookingTypes = {
  charter: 'charter',
  dp: 'independent',
};

export default bookingTypes;
